import { useState } from 'react';

const useContentSwitcher = () => {
  const [isPrimaryVisible, setIsPrimaryVisible] = useState<boolean>(true);

  const handleChangeContentType = () => {
    setIsPrimaryVisible(!isPrimaryVisible);
  };

  return {
    handleChangeContentType,
    isPrimaryVisible,
  };
};

export default useContentSwitcher;
